import { render, staticRenderFns } from "./viewDetails.vue?vue&type=template&id=00db8960&scoped=true&"
import script from "./viewDetails.vue?vue&type=script&lang=js&"
export * from "./viewDetails.vue?vue&type=script&lang=js&"
import style0 from "./viewDetails.vue?vue&type=style&index=0&id=00db8960&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00db8960",
  null
  
)

export default component.exports